import { useState, useEffect } from "react";
import { MdClose, MdOutlinePeople, MdChevronRight } from "react-icons/md";
import { FaMoneyBillWave, FaWrench } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { useNavigate } from "react-router-dom";
import { ModalHeader } from "./Styles/InputStyles";
import DrawerHeader from "./Common/DrawerHeader";
import { FiClipboard } from "react-icons/fi";

const PendingTasksModal = ({ onClose, pendingTasks }) => {
    const navigate = useNavigate();
    const [height, setHeight] = useState(window.innerHeight);


    const [tasks, setTasks] = useState({
        tenantActions: {
            moveInRequests: pendingTasks?.tenantActions?.moveInRequests || 0,
            moveInVerification: pendingTasks?.tenantActions?.moveInVerificationPending || 0,
            moveOutRequests: pendingTasks?.tenantActions?.moveOutRequests || 0,
            moveOutPending: pendingTasks?.tenantActions?.moveOutPending || 0,
            guestRequests: pendingTasks?.tenantActions?.guestRequests || 0
        },
        financeActions: {
            landlordPayments: pendingTasks?.financeActions?.landlordPaymentsPending || 0,
            refundRequests: pendingTasks?.financeActions?.refundRequests || 0,
            unpaidExpenses: pendingTasks?.financeActions?.unpaidExpences || 0,
        },
        operationsActions: {
            unassignedComplaints: pendingTasks?.operationActions?.unAssignedTenantComplaints || 0,
            agreementRenewals: pendingTasks?.operationActions?.agreementExpired || 0,
            unassignedPropComplaints: pendingTasks?.operationActions?.unAssignedPropComplaints || 0,
            unassignedLeads: pendingTasks?.operationActions?.unAssignedLeads || 0,
        }
    });

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleTaskClick = (type, count, route) => {
        if (count > 0 && route) {
            navigate(route);
            onClose();
        }
    };
    const taskSections = [
        {
            title: "Tenant Actions",
            icon: <MdOutlinePeople className="w-4 h-4" />,
            color: "text-primary-color/50",
            bgColor: "bg-primary-color/10",
            borderColor: "border-l-blue-500",
            tasks: [
                {
                    id: "moveInRequests",
                    label: "Move-In request pendings",
                    count: tasks.tenantActions.moveInRequests,
                    route: "/requests"
                },
                {
                    id: "moveInVerification",
                    label: "Move-In verification pendings",
                    count: tasks.tenantActions.moveInVerification,
                    route: "/reserve/tenants"
                },
                {
                    id: "moveOutPendings",
                    label: "Move-Out pendings",
                    count: tasks.tenantActions.moveOutPending,
                    route: "/moveout/pendingTenants"
                },
                {
                    id: "moveOutRequests",
                    label: "Move-Out request pending",
                    count: tasks.tenantActions.moveOutRequests,
                    route: "/requests"
                },
                {
                    id: "guestRequests",
                    label: "Guest request pending",
                    count: tasks.tenantActions.guestRequests,
                    route: "/requests"
                }
            ]
        },
        {
            title: "Finance Actions",
            icon: <FaMoneyBillWave className="w-4 h-4" />,
            color: "text-green-600",
            bgColor: "bg-green-50",
            borderColor: "border-l-green-500",
            tasks: [
                {
                    id: "landlordPayments",
                    label: "Landlord Payments Pending",
                    count: tasks.financeActions.landlordPayments,
                    route: "/landlord/pending-payouts"
                },
                {
                    id: "refundRequests",
                    label: "Refund request pending",
                    count: tasks.financeActions.refundRequests,
                    route: "/requests"
                },
                {
                    id: "unpaidExpenses",
                    label: "Unpaid Expense",
                    count: tasks.financeActions.unpaidExpenses,
                    route: "/properties/pending-exp"
                }
            ]
        },
        {
            title: "Operations Actions",
            icon: <FaWrench className="w-4 h-4" />,
            color: "text-purple-600",
            bgColor: "bg-purple-50",
            borderColor: "border-l-purple-500",
            tasks: [
                {
                    id: "unassignedComplaints",
                    label: "Unassigned Complaints",
                    count: tasks.operationsActions.unassignedComplaints,
                    route: "/complaints"
                },
                {
                    id: "agreementRenewals",
                    label: "Agreement Renewals Pending",
                    count: tasks.operationsActions.agreementRenewals,
                    route: "/tenants/agreement"
                },
                {
                    id: "unassignedPropComplaints",
                    label: "Unassigned Property Complaints",
                    count: tasks.operationsActions.unassignedPropComplaints,
                    route: "/complaints"
                },
                {
                    id: "unassignedLeads",
                    label: "Unassigned Leads",
                    count: tasks.operationsActions.unassignedLeads,
                    route: "/leads"
                }
            ]
        }
    ];

    return (
        <Container style={{ height: `${height}px` }}>
            {/* <ModalHeader>
                <h1 className="text-white text-lg font-medium">Pending Tasks</h1>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader> */}
            <DrawerHeader
                title="Pending Tasks"
                subtitle="Pending actions across properties"
                icon={<FiClipboard />}
                onClose={onClose}
            />

            <ContentContainer>
                <div className="px-4 py-4 space-y-4 bg-[#f8fafc]">
                    {taskSections.map((section, index) => (
                        <TaskCard key={index}>
                            {/* Header */}
                            <TaskHeader>
                                <div className="flex items-center gap-3">
                                    <div className={`
                                        w-10 h-10 rounded-2xl
                                        flex items-center justify-center
                                        ${section.bgColor}
                                    `}>
                                        <div className={`${section.color} text-lg`}>
                                            {section.icon}
                                        </div>
                                    </div>

                                    <div>
                                        <p className="font-semibold text-gray-900 text-[15px]">
                                            {section.title}
                                        </p>

                                        <p className="text-xs text-gray-500">
                                            Pending operational actions
                                        </p>
                                    </div>
                                </div>

                                <TaskBadge>
                                    {section.tasks.reduce((a, b) => a + b.count, 0)}
                                </TaskBadge>
                            </TaskHeader>

                            <Divider />

                            {/* Content */}
                            <TaskGrid>
                                {
                                    [...section.tasks]
                                        .sort((a, b) => b.count - a.count)
                                        .map(task => (
                                            <TaskItem key={task.id} className={section.borderColor}>
                                                <TaskRow
                                                    disabled={task.count === 0}
                                                    onClick={() =>
                                                        handleTaskClick(task.id, task.count, task.route)
                                                    }
                                                >
                                                    <div className="flex items-center gap-3 flex-1 min-w-0">
                                                        <div className={`
            w-2 h-2 rounded-full
            ${task.count > 0 ? 'bg-rose-500' : 'bg-gray-300'}
        `} />

                                                        <FlexCol>
                                                            <Label>{task.label}</Label>

                                                            <span className="text-xs text-gray-400">
                                                                {task.count > 0
                                                                    ? 'Requires attention'
                                                                    : 'No pending actions'}
                                                            </span>
                                                        </FlexCol>
                                                    </div>

                                                    <TaskRight>
                                                        <div
                                                            className={`
                                                        min-w-[36px]
                                                        h-[36px]
                                                        px-2
                                                        rounded-xl
                                                        flex items-center justify-center
                                                        text-sm font-bold
                                                        transition-all
                                                        ${task.count > 0
                                                                    ? 'bg-rose-50 text-rose-600'
                                                                    : 'bg-gray-100 text-gray-400'
                                                                }
                                                    `}
                                                        >
                                                            {task.count}
                                                        </div>

                                                        <ArrowIcon active={task.count > 0}>
                                                            <MdChevronRight size={20} />
                                                        </ArrowIcon>
                                                    </TaskRight>
                                                </TaskRow>
                                            </TaskItem>
                                        ))}
                            </TaskGrid>
                        </TaskCard>
                    ))}
                </div>
            </ContentContainer>
            <div className="
    sticky bottom-0
    bg-white/90 backdrop-blur-md
    border-t border-gray-200
    px-4 py-3
">
                <div className="flex items-center justify-between">
                    <p className="text-sm text-gray-500">
                        Total Pending Actions
                    </p>

                    <p className="text-xl font-bold text-gray-900">
                        {
                            taskSections.reduce(
                                (sum, section) =>
                                    sum +
                                    section.tasks.reduce((a, b) => a + b.count, 0),
                                0
                            )
                        }
                    </p>
                </div>
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col overflow-hidden`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4 flex-shrink-0`;
const ContentContainer = tw.div`flex-1 overflow-y-auto max-h-[calc(100vh-100px)]`;
//const TaskCard = tw.div`bg-white border border-gray-100 rounded-lg p-4 shadow-sm`;
const TaskCard = tw.div`
    bg-white
    border border-gray-200/70
    rounded-2xl
    p-4
    shadow-[0_2px_12px_rgba(0,0,0,0.04)]
    backdrop-blur-sm
`;
const TaskHeader = tw.div`flex items-center justify-between`;
//const TaskBadge = tw.span`text-xs px-3 py-1 rounded-full bg-primary-color/10 text-primary-color font-medium`;
const TaskBadge = tw.span`
    min-w-[34px]
    h-[34px]
    px-3
    rounded-full
    flex items-center justify-center
    text-sm font-semibold
    bg-primary-color
    text-white
    shadow-sm
`;
const TaskGrid = tw.div`flex flex-col`;
//const TaskItem = tw.div`hover:bg-gray-50 transition-colors duration-150`;
const TaskItem = tw.div`
    rounded-xl
    transition-all
    duration-200
    hover:bg-gray-50
`;
//const TaskRow = tw.div`flex items-center justify-between py-2 cursor-pointer min-h-[44px]`;
const TaskRow = tw.div`
    flex items-center justify-between
    py-3 px-2
    rounded-xl
    cursor-pointer
    min-h-[56px]
    transition-all
`;
const TaskCount = tw.span`min-w-[24px] text-right text-sm font-medium  ${({ active }) => active ? "text-red-600" : "text-gray-400"}`;
const Divider = tw.div`h-px bg-gray-100 my-3`;
const Label = tw.label`text-sm text-gray-800 font-medium line-clamp-1`;
const FlexCol = tw.div`flex flex-col gap-0.5 flex-1`;
const TaskRight = tw.div`flex items-center gap-2`;
const ArrowIcon = tw.span`transition-all ${({ active }) => active ? "text-gray-700" : "text-gray-300"}`;

export default PendingTasksModal;